import React, { SVGProps } from 'react'

export const GooglePlayQRCodeIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 116 } = props
  return (
    <svg
      width={width}
      viewBox='0 0 1125 1125'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clip-path='url(#clip0_5909_12212)'>
        <path
          d='M0 1125V0H1125V1125H0ZM449.98 999.91H474.7V975.05H449.97V949.81H475.14V924.92L475 925.06H499.74V874.78H474.99V849.89H500.24V824.89H525.14V899.91H575.16V1000.05H550.43V1024.92H575.16V1074.59H600.29V1050.34H625.2V1074.69H725.29V1050.24H750.2V1074.61H775.28V999.88H800.06V949.91H825.38V925.27H850.26V999.6H875.32V975.32H950.23V1000.06H925.5V1024.93H950.23V1049.65H1000.09V1024.92C1008.47 1024.92 1016.85 1024.92 1025.23 1024.92V1074.64H1050.1V1024.92H1074.84V974.8H1025.25V949.93L1025.11 950.07H1050.38V899.85H1074.88V849.84H1049.94V800.05H950.08V774.8H1000.35V700.05H1025.22L1025.08 699.91V724.56H1074.87V650.32H1000.03V675.03H974.95V725.11H950.04V750.03H925.06V724.78H900.06V699.89H925.07V674.88H950.38V649.78H975.26V624.74H1050.29V599.88H1074.8V574.83H1050.46V549.78H1074.92V524.92H1000.02V475.03C991.35 475.03 983.21 475.03 975.07 475.03V449.78H1000.06C1000.06 441.14 1000.06 433.01 1000.06 424.89H1049.77V450.09H1025.46V474.58H1074.76V375.21H1050.03V400.02C1033.02 400.02 1016.56 400.02 1000.09 400.02V374.72H1024.89V350.23H975.48V399.88H1000.23C1000.23 408.26 1000.21 416.65 1000.2 425.03H949.95V375.01H900.05V349.69H924.86V250.26H849.89V274.66H824.99V249.69H799.83C799.83 240.99 799.83 232.85 799.84 224.71H825.05V199.84H850.34V224.67H874.82V150.27H825.19C825.19 167.07 825.19 183.53 825.19 199.99H799.98V224.84C791.66 224.9 783.35 224.96 775.03 225.02V174.76H800.04V124.85H874.73V50.17H800.43V75.13H849.85V100.02H800.19C800.19 108.7 800.19 116.84 800.19 124.98H774.88V150.06H700.38V175.08H750.17V225H724.92V200.31H700.15V250.01H674.84V200.2H649.96V250.01C641.28 250.01 633.14 250.01 625 250.01C625 216.62 625 183.23 625 149.84C633.37 149.84 641.74 149.84 650.12 149.84V174.59H674.71V149.98H649.98V124.66H699.79V99.76H675.31V74.86H699.71V50.16H625.37V75.11H649.8V100.01H625.14C625.14 117.03 625.14 133.5 625.14 149.97H600.12V250H574.87V200C566.23 200 558.1 200 549.97 200V174.74H574.64V149.77H524.75C524.75 141.19 524.75 132.94 524.76 124.69H549.97V99.82H599.65V74.73H574.92V50.29H525.29V75.01H550.11C550.11 83.69 550.11 91.83 550.11 99.96H524.9V124.81H499.88V100.2H475.33V150.08H500.1C500.1 158.73 500.1 166.86 500.1 174.98H475.09V199.99H449.84V224.99C441.19 224.99 433.07 224.99 424.94 224.99V199.98H399.93V175.26H375.07V199.99C366.69 199.94 358.32 199.88 349.94 199.83L350.08 199.97V149.73H324.91C324.91 132.75 324.91 116.3 324.91 99.85H375.12V75H400.18V100.02H425.08C425.08 108.69 425.08 116.83 425.08 124.96H400.33V149.54H424.94V124.81H449.61V74.71H424.87V50.29H375.27C375.27 58.83 375.27 66.98 375.26 75.12H349.92V50.25H325.04V99.99H299.73V50.19H274.86V150.14H250.24V175.03H275.05C275.05 183.71 275.05 191.85 275.05 199.99H249.81V250.12H200.03C200.03 258.75 200.03 266.87 200.03 275H175.01V300.02H150.28V324.58H174.87C174.87 316.11 174.87 308 174.87 299.88C183.26 299.88 191.65 299.88 200.03 299.87V325.12H225.03C225.03 333.77 225.03 341.89 225.03 350.01H200.3V374.88H225.03V399.57H174.81V349.89H124.79V300.02C107.79 300.02 91.33 300.02 74.87 300.02V275.27H50.29V299.88H75.02V325.18H50.2V350.06H75.02C75.02 358.74 75.02 366.87 75.02 375.01H50.27V399.59H74.88V374.86H149.64V400.12H125.02C125.02 408.77 125.02 416.9 125.02 425.02H100.29V449.89H125.02V474.64H175.13V450.04H200.01L199.87 449.9V475.18H224.7V500.02H175.29V549.88H200.02C200.02 558.27 200.02 566.65 200.02 575.04C183.25 575.11 166.48 575.17 149.72 575.23V500.24H124.81V525.04H99.87V475.31H75.01C75.01 492.12 75.01 508.57 75.01 525.03H50.28V549.9H75.01C75.08 566.67 75.14 583.44 75.2 600.2H50.32V624.92H75.02C75.02 641.63 75.02 658.33 75.02 675.04H50.27V724.61H74.88V674.89C83.25 674.89 91.63 674.89 100 674.89V699.64H149.58V675.03H99.86V649.79H149.57V625.05C124.42 625.05 99.65 625.05 74.89 625.05C74.95 616.72 75.01 608.39 75.07 600.07H125.13V575.09H149.86V600.16H175.1V624.89H250.04C250.04 633.28 250.04 641.66 250.04 650.05H200.03V675.05H175.04C175.04 692.11 175.04 708.58 175.04 725.04H150.31V749.91H175.04C175.04 758.29 175.04 766.67 175.04 775.06H100.34V824.58H125.2V800.33H150.08C150.08 817.13 150.08 833.59 150.08 850.05H75.31V874.65H149.93V849.91C166.64 849.91 183.35 849.91 200.07 849.92V874.92H250.08V924.93H275.09V950.15H300.22V974.93H325.09V1000.09H299.85V1025.1C291.21 1025.1 283.09 1025.1 274.96 1025.1V975.35H250.36V1024.96H275.1V1049.95H350.09V1074.68H374.96V1049.95C383.34 1049.95 391.73 1049.95 400.11 1049.95V1074.7H474.7V1025.09H449.97V999.93L449.98 999.91ZM750.03 99.83H774.76V50.28H750.17C750.17 67.09 750.17 83.53 750.17 99.97H725.42V124.55H750.03V99.83ZM224.65 224.71V50.31H50.24V224.71H224.65ZM50.33 900.2V1074.59H224.74V900.2H50.33ZM1074.79 224.7V50.31H900.38V224.7H1074.79ZM924.88 1049.81H899.83V1025.26H849.99V1050.2H800.35V1074.74H924.89V1049.81H924.88ZM974.87 324.7V250.23H950.47V324.7H974.87ZM500.42 949.88V974.74H549.75V925.35H524.92V949.88H500.41H500.42ZM100.21 274.57H149.59V250.19H100.21V274.57ZM1024.77 324.72V275.17H1000.42V324.72H1024.77ZM475.41 50.12V74.5H499.77V50.12H475.41ZM1074.85 774.72V750.3H1050.52V774.72H1074.85ZM50.35 800.18V824.74H74.7V800.18H50.35ZM525.45 1050.18V1074.74H549.75V1050.18H525.45ZM1050.34 349.55H1074.9V325.23H1050.34V349.55ZM1074.81 299.7V275.32H1050.41V299.7H1074.81Z'
          fill='white'
        />
        <path
          d='M75.0602 374.99V350.05H50.2402V325.17H75.0602V299.87L74.9202 300.01H124.84V349.88H174.86V399.56H225.08V374.87L224.93 375.01C241.64 374.96 258.35 374.91 275.06 374.86C275 383.19 274.94 391.52 274.88 399.84H250.4V449.68H274.73C274.73 432.85 274.73 416.28 274.73 399.71C283.09 399.71 291.45 399.71 299.62 399.71V374.99H274.92C274.97 358.28 275.02 341.57 275.08 324.86L274.94 325C299.99 325 325.03 325.01 350.08 325.02L349.94 324.88V349.54H399.76V274.82H375.1V249.86L374.96 250H425.11L424.97 249.86V275H450.11L449.97 274.86V325L450.11 324.86H425.1V375.01H375.41V450.1H399.71V500.02C391.25 500.02 383.11 500.02 374.98 500.02C374.98 491.76 374.98 483.5 374.98 474.71H349.87V450.25H299.82V475.07H274.94V500.12H250.26V524.64H300.18V499.88H375.12V525.12H325.1V550.01H300.37V574.88H325.1V600.13H249.94V625.02L250.08 624.87H175.14V600.14H149.9C149.9 591.55 149.9 583.31 149.9 575.06L149.76 575.22C166.53 575.15 183.3 575.09 200.07 575.02L199.93 574.87V599.59H225.07V574.87L224.93 575.01H274.65V549.87H224.93L225.07 550.01V525.29H199.93V550.01L200.07 549.86H175.34V500H224.75V475.16H199.92C199.92 466.38 199.92 458.13 199.92 449.88C208.16 449.88 216.4 449.88 224.67 449.88V425.3H200.06V450.03H175.18V474.63H125.07V449.88L124.92 450.02H149.64V424.88H124.92L125.07 425.02V400.12H149.69V374.86H74.9202L75.0602 375V374.99ZM325.11 424.63H349.68V375.32H325.11V424.63Z'
          fill='black'
        />
        <path
          d='M1025.23 949.93V974.8H1074.82V1024.92H1050.08L1050.22 1025.07V1000.35H1025.08V1025.07L1025.22 1024.92C1016.84 1024.92 1008.46 1024.92 1000.08 1024.92L1000.22 1025.07V975.31H974.96V999.92H950.07L950.22 1000.06V975.32H875.31V999.6H850.25V925.27H825.37V949.91H800.05L800.19 950.06V924.75H774.94V899.87H750.05V874.91H775.04V824.92C783.29 824.92 791.54 824.92 799.77 824.92V800.05H775.04V774.76H800.28V749.9H825.29V650.05H850.2L850.06 649.91V675.13H875.34V700.05H900.21L900.06 699.91V724.8H925.06V750.05L925.21 749.91H900.48V800.05H925.21L925.07 799.91V849.63H950.21V799.91L950.07 800.06H1049.93V849.85H1074.87V899.86H1050.37V950.08C1041.6 950.08 1033.35 950.08 1025.1 950.08C1025.1 941.82 1025.1 933.55 1025.1 924.76H1000.43V899.87H1024.75V875.28H975.48V949.94H1025.24L1025.23 949.93ZM875.33 949.63H949.72V875.25H875.33V949.63ZM825.3 849.65H899.73V824.82H875.03V799.79H850V775.26H825.31V849.64L825.3 849.65ZM849.9 875.36H825.34V899.71H849.9V875.36Z'
          fill='black'
        />
        <path
          d='M975.06 475.02H1000V524.91H1074.9V549.77H1050.44V574.82H1074.78V599.87H1050.27V624.73H975.24V649.77H950.359V674.87H925.049L925.19 675.02C925.14 658.31 925.089 641.6 925.039 624.89C933.279 624.89 941.519 624.89 949.789 624.89V600.31H925.18V625.03H899.919V649.88H850.039L850.18 650.02V624.73H874.859V600.25H824.94V624.86H750.039L750.18 625V574.71H774.84V525.26H749.88V549.67H725.25V424.81H749.729V400.17H724.95V409.47H700.159V349.85L700.02 349.99C708.4 349.99 716.78 350 725.15 350.01L725.01 349.87V374.61H775.289V350H800.18L800.039 349.86V374.58H825.18V349.86L825.039 350H850.18L850.039 349.86V400.17H874.84V424.6H824.87V400.21H775.43V474.86H800.169V500.16H825.25V550.01H850.289V574.71H875.159V549.79H900.049V499.86C908.429 499.86 916.81 499.86 925.19 499.86V524.88H950.21C950.21 533.25 950.21 541.62 950.21 550C941.97 550 933.73 550 925.46 550V574.58H950.07V549.86C958.44 549.86 966.82 549.86 975.19 549.86C975.19 558.1 975.19 566.34 975.19 574.61H999.77V550H975.039V525.02C966.329 525.02 958.2 525.02 950.07 525.02C950.07 516.63 950.07 508.25 950.06 499.86H975.2V474.87L975.06 475.02Z'
          fill='black'
        />
        <path
          d='M549.99 200H574.89V250C583.64 250 591.89 250 600.14 250L600 249.85C599.98 258.17 599.96 266.5 599.95 274.82H575.47V299.67H599.8C599.8 291.18 599.8 282.93 599.8 274.69C608.16 274.69 616.52 274.69 625.15 274.69V249.84L625.01 249.99H649.97V200.18H674.85V249.99H700.16L700.02 249.84V275.15H724.82V300.04H700.02V349.99L700.16 349.85H674.88V275.15H650.03V300.07H624.81V325.11H599.94V349.99H575V325.26H550.13V349.99H500.12V374.99C483.41 374.99 466.69 374.99 449.98 374.99C450.03 358.27 450.07 341.56 450.12 324.84L449.98 324.98H499.67V299.74H474.94V274.84H449.98L450.12 274.98V249.84H424.98L425.12 249.98V224.84L424.98 224.99H449.88V199.99H475.13L474.99 199.84V250.15H525.24V274.58H550.14V199.84L550 199.99L549.99 200Z'
          fill='black'
        />
        <path
          d='M800.031 949.91V999.88H775.25V1074.61H750.17V1050.24H725.26V1074.69H625.17V1050.34H600.26V1074.59H575.13V1024.92L574.98 1025.06H650.22V1049.6H699.82V999.92H674.901V974.91H624.99L625.13 975.05V949.91L624.99 950.05H650.13V924.91L649.99 925.05H700.3V974.72H775.19V950.06H800.16L800.021 949.91H800.031ZM749.87 1000.35H725.49V1024.73H749.87V1000.35Z'
          fill='black'
        />
        <path
          d='M224.65 224.71H50.2402V50.3101H224.65V224.71ZM76.4302 198.44H198.47V76.4901H76.4302V198.43V198.44Z'
          fill='black'
        />
        <path
          d='M50.3301 900.2H224.74V1074.59H50.3301V900.2ZM198.56 926.47H76.5101V1048.42H198.56V926.47Z'
          fill='black'
        />
        <path
          d='M1074.79 224.7H900.38V50.3101H1074.79V224.7ZM1048.66 198.48V76.4401H926.69V198.48H1048.66Z'
          fill='black'
        />
        <path
          d='M799.82 224.69V249.68H824.98V274.65H849.88V250.25H924.85V349.68H900.04C900.04 358.48 900.04 366.74 900.04 375L900.19 374.86H874.94V349.86H850.04L850.18 350V324.69H874.84V300.26H825.04V350L825.18 349.86H800.04L800.18 350V299.75H750.17V249.85L750.03 249.99H775.17V224.85L775.03 225C783.35 224.94 791.66 224.88 799.98 224.83L799.82 224.69Z'
          fill='black'
        />
        <path
          d='M324.94 99.8599V149.74H350.11C350.11 166.84 350.11 183.41 350.11 199.98C341.87 199.98 333.63 199.98 325.36 199.98V224.56H349.97V199.84C358.35 199.89 366.72 199.95 375.1 200L374.96 199.85V249.99L375.1 249.85H324.79V299.65H299.91V199.85H274.95L275.1 199.99V175.03H250.29V150.14H274.91V50.1899H299.78V99.9999H325.09L324.95 99.8599H324.94Z'
          fill='black'
        />
        <path
          d='M1025.2 700.05H1000.33V774.8H950.06C950.06 783.55 950.06 791.8 950.06 800.05L950.2 799.9H925.06L925.2 800.04V749.9L925.05 750.04C933.19 750.04 941.34 750.04 950.03 750.04V725.12H974.94V675.04H1000.02V650.33H1074.86V724.57H1025.07V699.92C1033.31 699.92 1041.55 699.92 1049.82 699.92V675.34H1025.21V700.07L1025.2 700.05Z'
          fill='black'
        />
        <path
          d='M525.12 824.9H500.22V849.9H474.97L475.11 850.05V799.84H449.82V775.04H399.95C399.95 766.66 399.95 758.28 399.95 749.89H475.1C475.1 758.14 475.1 766.38 475.1 774.62H499.97V749.89H525.24V775.25H575.22V800.07H599.69V824.91H549.97L550.11 825.05V800.33H524.97V825.05L525.11 824.9H525.12Z'
          fill='black'
        />
        <path
          d='M225.08 350V325.11H200.08C200.08 316.35 200.08 308.11 200.08 299.86L199.93 300H224.65V274.86H199.93L200.08 275V250.12H249.86V199.99C258.6 199.99 266.85 199.99 275.1 199.99L274.95 199.85V325L275.09 324.86H249.84V349.86H224.94L225.09 350H225.08Z'
          fill='black'
        />
        <path
          d='M474.98 849.9V874.79H499.73V925.07C491.48 925.07 483.23 925.07 474.99 925.07C474.99 916.83 474.99 908.59 474.99 900.32H450.41V924.93H475.14V949.82H449.97V975.06L450.12 974.92L424.97 975.06C424.97 933.34 424.97 891.62 424.97 849.91C441.69 849.96 458.4 850.01 475.12 850.06L474.98 849.91V849.9Z'
          fill='black'
        />
        <path
          d='M1000.05 424.89V449.78H975.06C975.06 458.54 975.06 466.78 975.06 475.03L975.2 474.88L950.05 475.02V449.75H900.19V374.88L900.04 375.02C916.5 375.02 932.96 375.02 949.94 375.02V425.04H1000.19L1000.05 424.9V424.89Z'
          fill='black'
        />
        <path
          d='M200.07 849.9C183.36 849.9 166.65 849.9 149.93 849.89L150.07 850.03V800.31H125.19V824.56H100.33V775.04H175.06L174.92 774.89V800.03H225.07L224.93 799.89V825.14H199.93V850.04L200.07 849.89V849.9Z'
          fill='black'
        />
        <path
          d='M575.14 1000.06V899.92L574.99 900.06H625V874.91H650.14C650.09 891.63 650.05 908.34 650 925.06L650.14 924.92H625V950.06L625.14 949.92H600.42V975.06H625.14L625 974.92V999.92H574.99L575.14 1000.06Z'
          fill='black'
        />
        <path
          d='M625.159 149.97V100.01H649.82V75.1099H625.39V50.1599H699.729V74.8599H675.33V99.7599H699.81V124.66H650V149.98L650.14 149.84C641.77 149.84 633.4 149.84 625.02 149.84L625.159 149.98V149.97Z'
          fill='black'
        />
        <path
          d='M99.9202 525.03H124.86V500.23H149.77C149.77 525.14 149.77 550.18 149.77 575.23C149.77 575.23 149.91 575.07 149.9 575.08C141.77 575.08 133.65 575.08 125.17 575.08V600.06C108.24 600.06 91.6802 600.06 75.1002 600.06L75.2602 600.2C75.1902 583.43 75.1302 566.66 75.0602 549.89L74.9102 550.03H100.05V524.89L99.9102 525.04L99.9202 525.03Z'
          fill='black'
        />
        <path
          d='M800.19 124.97V100.02H849.85V75.1299H800.43V50.1699H874.73V124.83H800.04L800.18 124.97H800.19Z'
          fill='black'
        />
        <path
          d='M524.78 124.68V149.77H574.67V174.74H550V200L550.14 199.85C541.76 199.9 533.38 199.95 525 200V174.85H499.99L500.14 174.99V150.09H475.37V100.21H499.92V124.82C508.48 124.82 516.71 124.82 524.95 124.82L524.79 124.68H524.78Z'
          fill='black'
        />
        <path
          d='M800.04 124.83V174.74H775.03V225L775.17 224.85H750.03L750.18 224.99V175.07H700.39V150.05H774.89V124.97C783.68 124.97 791.94 124.97 800.2 124.97L800.06 124.83H800.04Z'
          fill='black'
        />
        <path
          d='M1000.19 425.03C1000.19 416.65 1000.21 408.26 1000.22 399.88L1000.08 400.02H1050.02V375.21H1074.75V474.58H1025.45V450.09H1049.76V424.89C1033.22 424.89 1016.63 424.89 1000.05 424.89L1000.19 425.03Z'
          fill='black'
        />
        <path
          d='M924.89 1049.82V1074.75H800.35V1050.21H849.99V1025.27H899.83V1049.82H924.88H924.89Z'
          fill='black'
        />
        <path
          d='M375.31 75.1501V50.3101H424.91V74.7301H449.65V124.83H424.98L425.12 124.97V100.03H400.22V75.0101C391.64 75.0101 383.4 75.0101 375.15 75.0101L375.31 75.1501Z'
          fill='black'
        />
        <path
          d='M825.19 199.98V150.26H874.82V224.66H850.34V199.83H825.05L825.19 199.97V199.98Z'
          fill='black'
        />
        <path
          d='M550.14 99.9701V75.02H525.32V50.3H574.95V74.74H599.68V99.8301H550L550.14 99.9701Z'
          fill='black'
        />
        <path
          d='M100.04 674.88C91.6699 674.88 83.2899 674.88 74.9199 674.88L75.0599 675.02V624.9L74.9199 625.04H149.6V649.78H99.8899V675.02L100.03 674.88H100.04Z'
          fill='black'
        />
        <path
          d='M449.98 1025.07H474.71V1074.68H400.12V1049.93L399.97 1050.07H450.12V1024.93L449.98 1025.08V1025.07Z'
          fill='black'
        />
        <path
          d='M175.06 775.05C175.06 766.67 175.06 758.29 175.06 749.9L174.91 750.04C199.96 749.99 225.01 749.94 250.06 749.89C250.06 766.61 250.06 783.33 250.06 800.05C241.68 800 233.3 799.95 224.92 799.9L225.06 800.04V774.9H174.91L175.05 775.05H175.06Z'
          fill='black'
        />
        <path
          d='M575.141 899.91H525.12C525.12 874.74 525.12 849.82 525.12 824.89L524.98 825.04H550.12L549.98 824.9V874.9H575.12C575.07 883.28 575.03 891.67 574.98 900.05L575.13 899.91H575.141Z'
          fill='black'
        />
        <path
          d='M625.01 149.83C625.01 183.22 625.01 216.61 625.01 250L625.15 249.85H600.01L600.15 250C600.15 216.86 600.15 183.72 600.15 149.97C608.64 149.97 616.9 149.97 625.17 149.97L625.03 149.83H625.01Z'
          fill='black'
        />
        <path
          d='M274.96 1025.07H299.85V1000.06H325.09L324.95 999.91V1025.16H349.95V1050.06L350.09 1049.91H275.1V1024.92L274.96 1025.06V1025.07Z'
          fill='black'
        />
        <path
          d='M175.07 725.03V675.04H200.06L199.92 674.89V700.13H224.61V724.89H174.91L175.06 725.03H175.07Z'
          fill='black'
        />
        <path d='M974.87 324.71H950.47V250.24H974.87V324.71Z' fill='black' />
        <path d='M500.42 949.88H524.93V925.35H549.76V974.74H500.43V949.88H500.42Z' fill='black' />
        <path
          d='M325.09 974.91H300.22V950.13H275.09V924.91L274.94 925.05H324.95V975.05L325.09 974.9V974.91Z'
          fill='black'
        />
        <path
          d='M700.15 250V200.3H724.92V224.99C733.68 224.99 741.92 224.99 750.17 224.99L750.02 224.85V249.99L750.16 249.85H700.01L700.15 250Z'
          fill='black'
        />
        <path
          d='M1000.22 399.88H975.47V350.23H1024.88V374.72H1000.08C1000.08 383.51 1000.08 391.76 1000.08 400.02L1000.22 399.88Z'
          fill='black'
        />
        <path
          d='M149.93 849.89V874.63H75.3096V850.03C100.27 850.03 125.17 850.03 150.07 850.03L149.93 849.89Z'
          fill='black'
        />
        <path
          d='M325.08 100V50.27H349.96V75.14C358.76 75.14 367.03 75.14 375.3 75.14C375.3 75.14 375.14 75 375.15 75.01C375.15 83.12 375.15 91.23 375.15 99.86C358.07 99.86 341.5 99.86 324.94 99.86L325.08 100Z'
          fill='black'
        />
        <path d='M750.18 99.97V50.28H774.77V99.83H750.04L750.18 99.97Z' fill='black' />
        <path
          d='M250.08 874.9H200.07C200.07 866.42 200.07 858.16 200.07 849.9L199.93 850.05C216.65 850 233.36 849.95 250.08 849.9C250.03 858.28 249.99 866.67 249.94 875.05L250.08 874.9Z'
          fill='black'
        />
        <path
          d='M275.09 924.92H250.08C250.08 908.09 250.08 891.5 250.08 874.91L249.94 875.06C258.32 875.01 266.71 874.97 275.09 874.92C275.04 891.63 274.99 908.35 274.94 925.06L275.09 924.92Z'
          fill='black'
        />
        <path
          d='M275.1 1024.93H250.36V975.32H274.96C274.96 991.94 274.96 1008.51 274.96 1025.07L275.1 1024.93Z'
          fill='black'
        />
        <path
          d='M400.11 1049.93C391.73 1049.93 383.34 1049.93 374.96 1049.93L375.1 1050.08V999.93H400.1C400.05 1016.65 400.01 1033.36 399.96 1050.08L400.11 1049.94V1049.93Z'
          fill='black'
        />
        <path
          d='M1000.07 1024.91V1049.64H950.21V1024.92L950.06 1025.06H1000.21L1000.07 1024.91Z'
          fill='black'
        />
        <path d='M100.21 274.57V250.19H149.59V274.57H100.21Z' fill='black' />
        <path
          d='M1050.08 1024.92V1074.64H1025.21V1024.92L1025.07 1025.07H1050.21L1050.07 1024.92H1050.08Z'
          fill='black'
        />
        <path d='M1024.77 324.73H1000.42V275.18H1024.77V324.73Z' fill='black' />
        <path
          d='M75.0599 525.02V475.3H99.9199C99.9199 491.88 99.9199 508.45 99.9199 525.03L100.06 524.88H74.9199L75.0699 525.02H75.0599Z'
          fill='black'
        />
        <path
          d='M200.07 675.04V650.04H250.08L249.94 649.89V674.89H199.93L200.07 675.04Z'
          fill='black'
        />
        <path
          d='M74.9196 674.87V724.59H50.3096V675.02C58.5596 675.02 66.8096 675.02 75.0596 675.02L74.9196 674.88V674.87Z'
          fill='black'
        />
        <path
          d='M99.9004 675.02H149.62V699.63H100.04C100.04 691.38 100.04 683.13 100.04 674.88L99.9004 675.02Z'
          fill='black'
        />
        <path d='M475.41 50.1201H499.77V74.5001H475.41V50.1201Z' fill='black' />
        <path
          d='M550 99.8301V124.7C541.51 124.7 533.15 124.7 524.78 124.7C524.78 124.7 524.94 124.84 524.93 124.83C524.93 116.72 524.93 108.62 524.93 99.9801C533.66 99.9801 541.9 99.9801 550.14 99.9801L550 99.8401V99.8301Z'
          fill='black'
        />
        <path
          d='M750.03 99.8301V124.55H725.42V99.9701C733.69 99.9701 741.93 99.9701 750.17 99.9701L750.03 99.8301Z'
          fill='black'
        />
        <path
          d='M424.98 124.83V149.56H400.37V124.98C408.64 124.98 416.88 124.98 425.12 124.98L424.98 124.84V124.83Z'
          fill='black'
        />
        <path
          d='M649.99 149.98H674.72V174.59H650.13C650.13 166.32 650.13 158.08 650.13 149.84L649.99 149.98Z'
          fill='black'
        />
        <path
          d='M375.1 200V175.27H399.96V199.99L400.11 199.85H374.97L375.11 200H375.1Z'
          fill='black'
        />
        <path
          d='M475.11 200V174.99C483.6 174.99 491.86 174.99 500.12 174.99L499.97 174.85C500.02 183.23 500.06 191.62 500.11 200C491.73 199.95 483.35 199.9 474.97 199.85L475.11 200Z'
          fill='black'
        />
        <path
          d='M399.96 199.99H424.97C424.97 208.48 424.97 216.74 424.97 225L425.11 224.85H400.11V199.85L399.96 199.99Z'
          fill='black'
        />
        <path
          d='M825.05 199.83V224.7C816.56 224.7 808.2 224.7 799.83 224.7C799.83 224.7 799.99 224.84 799.98 224.83C799.98 216.72 799.98 208.62 799.98 199.98C808.71 199.98 816.95 199.98 825.19 199.98L825.05 199.84V199.83Z'
          fill='black'
        />
        <path d='M1074.86 774.72H1050.53V750.3H1074.86V774.72Z' fill='black' />
        <path
          d='M125.07 449.88H100.34V425.01H125.07L124.92 424.87V450.01L125.07 449.87V449.88Z'
          fill='black'
        />
        <path
          d='M925.06 674.89V699.9C916.57 699.9 908.31 699.9 900.05 699.9L900.2 700.04V675.04H925.2L925.06 674.89Z'
          fill='black'
        />
        <path
          d='M374.96 1049.92V1074.65H350.09V1049.92L349.95 1050.07H375.09L374.95 1049.92H374.96Z'
          fill='black'
        />
        <path d='M50.3496 800.18H74.6996V824.74H50.3496V800.18Z' fill='black' />
        <path d='M525.45 1050.18H549.75V1074.74H525.45V1050.18Z' fill='black' />
        <path
          d='M200.07 575.03C200.07 566.64 200.07 558.26 200.07 549.87L199.93 550.02H225.07L224.93 549.88V575.02L225.07 574.88H199.93L200.07 575.03Z'
          fill='black'
        />
        <path
          d='M74.9196 374.85V399.58H50.3096V375C58.5796 375 66.8196 375 75.0596 375L74.9196 374.86V374.85Z'
          fill='black'
        />
        <path
          d='M250.08 650.04C250.08 641.65 250.08 633.27 250.08 624.88L249.94 625.03H274.93V650.02L275.07 649.88C266.69 649.88 258.32 649.88 249.94 649.89L250.08 650.04Z'
          fill='black'
        />
        <path
          d='M75.0701 624.9H50.3701V600.18C58.5401 600.18 66.8901 600.18 75.2601 600.18C75.2601 600.18 75.1001 600.04 75.1101 600.05C75.0601 608.38 75.0001 616.71 74.9401 625.04L75.0801 624.9H75.0701Z'
          fill='black'
        />
        <path
          d='M225.08 374.87H200.35V350C208.58 350 216.83 350 225.08 350L224.93 349.86V375L225.08 374.86V374.87Z'
          fill='black'
        />
        <path d='M1050.34 349.55V325.23H1074.9V349.55H1050.34Z' fill='black' />
        <path
          d='M175.07 749.9H150.34V725.03H175.07L174.92 724.89V750.03L175.07 749.89V749.9Z'
          fill='black'
        />
        <path d='M174.91 299.88V324.58H150.32V300.02H175.05L174.91 299.88Z' fill='black' />
        <path
          d='M75.0601 549.88H50.3301V525.01C58.5601 525.01 66.8101 525.01 75.0601 525.01L74.9101 524.87V550.01L75.0601 549.87V549.88Z'
          fill='black'
        />
        <path
          d='M325.09 1000.07C325.09 991.68 325.09 983.3 325.09 974.91L324.95 975.06H349.67V999.92H324.95L325.09 1000.07Z'
          fill='black'
        />
        <path
          d='M449.97 975.05H474.7V999.91H449.98L450.12 1000.06V974.92L449.97 975.06V975.05Z'
          fill='black'
        />
        <path d='M1074.8 299.7H1050.4V275.32H1074.8V299.7Z' fill='black' />
        <path
          d='M175.06 300.02V275C183.56 275 191.82 275 200.08 275L199.93 274.86V300L200.08 299.86C191.69 299.86 183.3 299.86 174.92 299.87L175.06 300.01V300.02Z'
          fill='black'
        />
        <path
          d='M449.98 999.91V1025.07L450.12 1024.92H424.98V999.91C433.36 999.96 441.74 1000.01 450.12 1000.06L449.98 999.91Z'
          fill='black'
        />
        <path
          d='M575.14 1024.92H550.41V1000.05C558.64 1000.05 566.89 1000.05 575.14 1000.05L574.99 999.91V1025.05L575.14 1024.91V1024.92Z'
          fill='black'
        />
        <path
          d='M950.2 1024.92H925.47V1000.05C933.7 1000.05 941.95 1000.05 950.2 1000.05L950.05 999.91V1025.05L950.2 1024.91V1024.92Z'
          fill='black'
        />
        <path
          d='M75.0698 299.87H50.3398V275.26H74.9198C74.9198 283.53 74.9198 291.77 74.9198 300.01L75.0598 299.87H75.0698Z'
          fill='black'
        />
        <path
          d='M575.13 874.9H549.99V824.9H599.71V800.06H575.24V775.24H525.26V749.88H499.99L500.13 750.03V715.45H425.31V725.07H474.98V750.03L475.12 749.88H399.97L400.11 750.03V674.8H350.1V649.88L349.96 650.02H399.78V549.87H324.96L325.11 550.01V525.12H375.13V499.88L374.99 500.02H399.72V450.1H375.42V375.01C391.93 375.01 408.52 375.01 425.11 375.01L424.97 374.86V400.09H400.32V409.46H450.12V374.86L449.98 375.01C466.69 375.01 483.41 375.01 500.12 375.01L499.98 374.86V400H525.12L524.98 399.86V409.48H550.12V399.86L549.98 400H575.19V409.4H599.77V374.78H575.13V349.85L574.99 350H599.93V325.12H624.8V300.08H650.02V275.16H674.87V349.86H700.15V409.48H724.94V400.18H749.72V424.82H725.24V549.68H749.87V525.27H774.83V574.72H750.17C750.17 591.84 750.17 608.43 750.17 625.01C741.93 625.01 733.69 625.01 725.42 625.01V649.59H750.03V624.86H824.93V600.25H874.85V624.73H850.17V650.02H825.26V749.87H800.25V774.73H775.01V800.02L775.16 799.88H749.85V725.21H724.97V775.03C716.29 775.03 708.15 775.03 700.02 775.03C700.02 755.13 700.02 735.24 700.02 715.43H675V750.04H650.15C650.15 758.72 650.15 766.86 650.15 775C641.89 775 633.63 775 625.43 775V824.54H674.78V799.81H650V774.86C666.72 774.86 683.44 774.88 700.15 774.89V800.12H725.31V825.02H775.14L774.99 824.88V874.87H750L750.14 875.02V850.29H649.98V875.02L650.12 874.87H624.98L625.12 875.02V850.29H574.97V875.02L575.11 874.87L575.13 874.9ZM469.22 606.06C471.37 605.02 472.72 604.47 473.96 603.76C486.82 596.37 499.6 588.84 512.55 581.62C515.67 579.88 516.52 577.76 516.47 574.43C516.31 563.6 516.5 552.77 516.37 541.94C516.32 537.63 518.03 534.73 521.76 532.6C533.62 525.82 545.45 518.98 557.19 511.98C561.08 509.66 564.52 509.66 568.39 511.98C577.67 517.56 587.16 522.8 596.41 528.42C599.34 530.2 601.58 530.26 604.58 528.48C617.76 520.65 631.1 513.09 644.36 505.41C645.58 504.7 646.68 503.8 648.19 502.74C646.42 501.6 645.19 500.75 643.92 500C620.53 486.19 597.1 472.46 573.75 458.57C566.24 454.1 559.11 454.21 551.63 458.66C527.86 472.81 504.04 486.87 480.15 500.82C472.65 505.2 469.13 511.42 469.17 520.09C469.29 546.75 469.21 573.42 469.21 600.08V606.06H469.22ZM477.1 622.23C478.58 623.29 479.34 623.93 480.17 624.42C504.41 638.73 528.64 653.05 552.91 667.3C559.9 671.4 566.8 670.83 573.71 666.73C597.34 652.71 620.97 638.67 644.74 624.89C652.98 620.11 656.61 613.38 656.56 603.99C656.41 577.68 656.51 551.36 656.5 525.05C656.5 523.32 656.34 521.58 656.24 519.46C654.96 519.87 654.3 519.96 653.76 520.27C639.76 528.32 625.72 536.32 611.85 544.6C610.44 545.44 609.38 548.04 609.35 549.85C609.12 560.84 609.12 571.83 609.28 582.82C609.35 587.53 607.46 590.62 603.4 592.93C591.81 599.51 580.27 606.17 568.85 613.02C564.64 615.55 560.98 615.62 556.77 613.06C547.38 607.36 537.85 601.87 528.25 596.52C526.77 595.69 524.19 595.23 522.88 595.97C507.79 604.42 492.85 613.14 477.11 622.23H477.1ZM624.76 749.89V724.82H574.88V715.5H525.35V725.15H550.33V749.9H624.76V749.89ZM775.31 724.62H799.7V650.23H775.31V724.62ZM749.69 699.79V675.23H725.39V699.79H749.69ZM649.83 374.75V350.23H625.4V374.75H649.83ZM625.21 409.39H649.74V400.31H625.21V409.39Z'
          fill='white'
        />
        <rect x='425' y='425' width='275' height='275' fill='white' />
        <path
          d='M579.837 615.722H540.269C535.499 615.722 531.009 613.197 528.624 608.988L505.894 569.561C503.508 565.351 503.508 560.3 505.894 556.091L528.624 516.664C531.009 512.455 535.499 509.929 540.269 509.929H579.837L611.266 455.349C610.564 455.349 609.863 455.349 609.302 455.349H516.697C506.876 455.349 497.896 460.54 492.985 469.099L446.683 549.075C441.772 557.494 441.772 568.017 446.683 576.436L492.985 656.693C497.896 665.111 506.876 670.443 516.697 670.443H609.302C610.003 670.443 610.705 670.443 611.406 670.443L579.977 615.863L579.837 615.722Z'
          fill='#FF0044'
        />
        <path
          d='M679.318 549.08L633.016 468.823C632.735 468.262 632.314 467.7 631.893 467.139L600.464 521.719L620.247 556.095C622.633 560.305 622.633 565.356 620.247 569.565L600.464 603.941L631.893 658.521C632.314 657.96 632.735 657.399 633.016 656.837L679.318 576.58C684.229 568.162 684.229 557.639 679.318 549.22V549.08Z'
          fill='#28F981'
        />
        <path
          d='M174.93 750.04V724.9H224.63V700.14H199.94V674.9H249.95V649.9C258.33 649.9 266.7 649.9 275.08 649.89C275.08 658.13 275.08 666.37 275.08 674.64H299.66V650.03H274.93V625.04H249.94V600.15H325.1V574.9L324.95 575.04H374.7V600.19H349.96V650.05L350.1 649.91H324.96V725.06L325.1 724.92H274.89V700.36H249.95V750.06L250.09 749.91C225.04 749.96 199.99 750.01 174.94 750.06L174.93 750.04Z'
          fill='white'
        />
        <path
          d='M274.94 325V199.85H299.9V299.65H324.78V249.85H375.09V274.81H399.75V349.53H349.93C349.93 341.39 349.93 333.13 349.93 324.87C358.17 324.87 366.41 324.87 374.68 324.87V300.29H350.07V325.02C325.02 325.02 299.98 325.01 274.93 325H274.94Z'
          fill='white'
        />
        <path
          d='M375.12 499.89H300.18V524.65H250.26V500.13H274.94V475.08H299.82V450.26H349.87V474.72H374.98C374.98 483.51 374.98 491.77 374.98 500.03L375.12 499.89Z'
          fill='white'
        />
        <path d='M449.97 274.86H474.93V299.76H499.66V325H449.97V274.86Z' fill='white' />
        <path
          d='M224.94 375.01V349.87H249.84V324.87H275.09C275.04 341.58 274.99 358.29 274.93 375L275.07 374.86C258.36 374.91 241.65 374.96 224.94 375.01Z'
          fill='white'
        />
        <path d='M400.1 199.85V224.85H425.1V249.99H374.95V199.85H400.09H400.1Z' fill='white' />
        <path d='M224.94 575.02V549.88H274.66V575.02H224.94Z' fill='white' />
        <path
          d='M450.11 324.86C450.06 341.58 450.02 358.29 449.97 375.01L450.11 374.86H424.97L425.11 375.01C425.11 358.54 425.11 342.07 425.11 324.86H450.12H450.11Z'
          fill='white'
        />
        <path d='M325.12 424.64V375.33H349.69V424.64H325.12Z' fill='white' />
        <path
          d='M274.74 399.71V449.68H250.41V399.84C258.43 399.84 266.66 399.84 274.9 399.84L274.74 399.7V399.71Z'
          fill='white'
        />
        <path d='M424.97 249.86H450.11V275H424.97V249.86Z' fill='white' />
        <path
          d='M325.1 574.89H300.37V550.02H325.1L324.95 549.88V575.02L325.1 574.88V574.89Z'
          fill='white'
        />
        <path
          d='M200.06 450.03V425.3H224.67V449.88C216.4 449.88 208.16 449.88 199.92 449.88L200.06 450.02V450.03Z'
          fill='white'
        />
        <path d='M124.92 450.01V424.87H149.64V450.01H124.92Z' fill='white' />
        <path
          d='M274.93 375H299.63V399.72C291.46 399.72 283.11 399.72 274.74 399.72C274.74 399.72 274.9 399.86 274.89 399.85C274.94 391.52 275 383.19 275.06 374.86L274.92 375H274.93Z'
          fill='white'
        />
        <path d='M225.08 550.02H199.94V525.3H225.08V550.02Z' fill='white' />
        <path d='M199.93 574.88H225.07V599.6H199.93V574.88Z' fill='white' />
        <path
          d='M650.01 925.05C650.06 908.33 650.1 891.62 650.15 874.9L650.01 875.05H700.32V899.71H725.21V875.05H750.17L750.03 874.9C750.03 883.04 750.03 891.18 750.03 899.86H774.92V924.74H800.17V950.05H775.2V974.71H700.31V925.04H650L650.01 925.05Z'
          fill='white'
        />
        <path
          d='M875.33 949.63V875.25H949.72V949.63H875.33ZM924.88 900.27H900.44V924.62H924.88V900.27Z'
          fill='white'
        />
        <path
          d='M825.31 849.64V775.26H850V799.79H875.03V824.82H899.73V849.65H825.3L825.31 849.64Z'
          fill='white'
        />
        <path
          d='M1025.23 949.93H975.47V875.27H1024.74V899.86H1000.42V924.75H1025.09C1025.09 933.55 1025.09 941.81 1025.09 950.07L1025.23 949.93Z'
          fill='white'
        />
        <path
          d='M925.19 675.03H900.19V700.03H875.32V675.11H850.04V649.89H899.92V625.04H925.18L925.04 624.9C925.09 641.61 925.14 658.32 925.19 675.03Z'
          fill='white'
        />
        <path
          d='M950.06 1025.06V999.92H974.95V975.31H1000.21V1025.07H950.06V1025.06Z'
          fill='white'
        />
        <path d='M925.19 749.9V800.04H900.46V749.9H925.19Z' fill='white' />
        <path d='M925.05 799.9H950.19V849.62H925.05V799.9Z' fill='white' />
        <path
          d='M775.02 800.04H799.75V824.91C791.52 824.91 783.27 824.91 775.02 824.91L775.169 825.05V799.91L775.02 800.05V800.04Z'
          fill='white'
        />
        <path d='M849.9 875.35V899.7H825.34V875.35H849.9Z' fill='white' />
        <path d='M1050.21 1025.06H1025.07V1000.34H1050.21V1025.06Z' fill='white' />
        <path
          d='M900.19 374.87V449.74H950.05V475.01L950.2 474.87H925.06V500.01L925.2 499.86C916.82 499.86 908.44 499.86 900.06 499.86L900.2 500.01V474.87H850.05L850.19 475.01V450.28H800.04V475.01L800.18 474.86H775.44V400.21H824.88V424.6H874.85V400.17H850.05V349.86H874.95V374.86H900.2L900.19 374.87Z'
          fill='white'
        />
        <path
          d='M700.02 249.86H750.169V299.76H800.18V350.01H775.289V374.62H725.01C725.01 366.36 725.01 358.12 725.01 349.88C733.25 349.88 741.49 349.88 749.76 349.88V325.3H725.15V350.03C716.77 350.03 708.39 350.02 700.02 350.01V300.06H724.82V275.17H700.02V249.86Z'
          fill='white'
        />
        <path
          d='M900.05 499.87V549.8H875.16V574.72H850.29V550.02H825.25V500.17H800.17V474.87L800.03 475.02H850.18L850.04 474.88V524.64H875.3V500.03H900.19L900.05 499.88V499.87Z'
          fill='white'
        />
        <path d='M825.04 350V300.26H874.84V324.69H850.18V350H825.04Z' fill='white' />
        <path
          d='M950.21 550.01C950.21 541.64 950.21 533.27 950.21 524.89L950.07 525.03H975.04V550.01L975.18 549.87C966.81 549.87 958.43 549.87 950.06 549.87L950.2 550.01H950.21Z'
          fill='white'
        />
        <path d='M800.03 349.87H825.17V374.59H800.03V349.87Z' fill='white' />
        <path
          d='M925.18 625.05V600.33H949.79V624.91C941.52 624.91 933.28 624.91 925.04 624.91L925.18 625.05Z'
          fill='white'
        />
        <path
          d='M950.07 549.86V574.58H925.46V550C933.73 550 941.97 550 950.21 550L950.07 549.86Z'
          fill='white'
        />
        <path
          d='M975.04 550.01H999.77V574.62H975.19C975.19 566.35 975.19 558.11 975.19 549.87L975.05 550.01H975.04Z'
          fill='white'
        />
        <path
          d='M950.05 475.01L975.2 474.87V499.86H950.06L950.2 500.01V474.87L950.05 475.01Z'
          fill='white'
        />
        <path
          d='M950.21 524.89H925.19V499.87L925.05 500.02H950.19L950.05 499.87C950.05 508.26 950.05 516.64 950.06 525.03L950.2 524.89H950.21Z'
          fill='white'
        />
        <path
          d='M474.98 199.85C483.36 199.9 491.74 199.95 500.12 200L499.98 199.85V224.57H525.12V199.85L524.98 200C533.36 199.95 541.74 199.9 550.12 199.85V274.59H525.22V250.16H474.97V199.85H474.98Z'
          fill='white'
        />
        <path
          d='M500.12 375.01V350.01H550.13L549.99 349.86V400L550.13 399.86H524.99L525.13 400V374.86H499.99L500.13 375.01H500.12Z'
          fill='white'
        />
        <path
          d='M550.13 350.01V325.28H575V350.01L575.14 349.86H550L550.14 350.01H550.13Z'
          fill='white'
        />
        <path
          d='M599.79 274.69V299.67H575.46V274.82C583.5 274.82 591.72 274.82 599.95 274.82L599.79 274.68V274.69Z'
          fill='white'
        />
        <path
          d='M600 249.86H625.14V274.71C616.52 274.71 608.16 274.71 599.79 274.71C599.79 274.71 599.95 274.85 599.94 274.84C599.95 266.51 599.97 258.19 599.99 249.86H600Z'
          fill='white'
        />
        <path
          d='M574.99 1025.06V999.92H625V974.92H674.91V999.93H699.83V1049.61H650.23V1025.07H574.99V1025.06Z'
          fill='white'
        />
        <path d='M625 950.06V924.92H650.14V950.06H625Z' fill='white' />
        <path d='M625.14 975.06H600.42V949.92H625.14V975.06Z' fill='white' />
        <path d='M749.88 1000.35V1024.73H725.5V1000.35H749.88Z' fill='white' />
        <path
          d='M76.4297 198.43V76.49H198.47V198.43H76.4297ZM174.6 174.74V100.18H100.3V174.73H174.6V174.74Z'
          fill='white'
        />
        <path
          d='M198.56 926.47V1048.42H76.5098V926.47H198.56ZM174.64 1024.77V950.38H100.25V1024.77H174.64Z'
          fill='white'
        />
        <path
          d='M1048.66 198.48H926.69V76.4399H1048.66V198.48ZM1024.78 174.7V100.32H950.4V174.71H1024.78V174.7Z'
          fill='white'
        />
        <path d='M750.02 250V224.86H775.159V250H750.02Z' fill='white' />
        <path
          d='M349.97 199.84V224.56H325.36V199.98C333.63 199.98 341.87 199.98 350.11 199.98L349.97 199.84Z'
          fill='white'
        />
        <path
          d='M1025.2 700.05V675.32H1049.81V699.9C1041.54 699.9 1033.3 699.9 1025.06 699.9L1025.2 700.04V700.05Z'
          fill='white'
        />
        <path
          d='M399.97 749.89C399.97 758.27 399.97 766.65 399.97 775.04L400.12 774.9H375.4V800.04H400.12L399.98 799.9V824.9H349.97L350.11 825.04V800.04H324.96C325.01 774.99 325.06 749.94 325.11 724.9L324.97 725.04H350.28V700.24H375.16V750.04H400.11L399.97 749.89Z'
          fill='white'
        />
        <path
          d='M475.12 850.05C458.4 850 441.69 849.95 424.97 849.9L425.11 850.05V799.91H399.97L400.11 800.05V774.91L399.96 775.05H449.83V799.85H475.12V850.06V850.05Z'
          fill='white'
        />
        <path d='M550.13 825.04H524.99V800.32H550.13V825.04Z' fill='white' />
        <path
          d='M499.98 749.89V774.62H475.11C475.11 766.39 475.11 758.14 475.11 749.89L474.97 750.04H500.11L499.97 749.89H499.98Z'
          fill='white'
        />
        <path d='M199.93 300V274.86H224.65V300H199.93Z' fill='white' />
        <path
          d='M324.95 999.92H349.67V975.06H324.95V925.06H274.94C274.99 908.35 275.04 891.63 275.09 874.92L274.94 875.06H300.16V849.78H324.95V824.91C333.33 824.96 341.71 825.01 350.09 825.06L349.95 824.92V850.06H425.1L424.96 849.91C424.96 891.63 424.96 933.35 424.96 975.06L425.11 974.92C416.79 974.9 408.46 974.88 400.14 974.87V925.07C391.22 925.07 383.1 925.07 374.98 925.07C375.04 916.74 375.1 908.41 375.16 900.09H399.64V875.24H375.31C375.31 883.73 375.31 891.98 375.31 900.22C366.95 900.22 358.59 900.22 350.42 900.22V924.94H375.12V974.73C383.79 974.73 392.03 974.73 400.27 974.73C400.17 983.18 400.07 991.63 399.97 1000.07L400.11 999.92H375.11V1050.07H349.97V1025.17H324.97V999.92H324.95Z'
          fill='white'
        />
        <path
          d='M475.13 924.92H450.4V900.31H474.98C474.98 908.58 474.98 916.82 474.98 925.06L475.12 924.92H475.13Z'
          fill='white'
        />
        <path
          d='M450.11 1000.06C441.73 1000.01 433.35 999.96 424.97 999.91L425.11 1000.06V974.92L424.96 975.06L450.11 974.92V1000.06Z'
          fill='white'
        />
        <path
          d='M250.08 849.9C233.36 849.95 216.65 850 199.93 850.05V825.15H224.93V799.9C233.31 799.95 241.69 800 250.07 800.05L249.93 799.9V850.04L250.07 849.89L250.08 849.9Z'
          fill='white'
        />
        <path d='M174.93 774.9H225.08V800.04H174.93V774.9Z' fill='white' />
        <path
          d='M574.99 900.05C575.04 891.67 575.08 883.28 575.13 874.9L574.99 875.05H625.14L625 874.9C625 883.04 625 891.18 625 900.05H574.99Z'
          fill='white'
        />
        <path d='M74.9102 550.02V524.88H100.05V550.02H74.9102Z' fill='white' />
        <path
          d='M500.12 200C500.07 191.62 500.03 183.23 499.98 174.85H524.99V200L525.13 199.85H499.99L500.13 200H500.12Z'
          fill='white'
        />
        <path
          d='M424.97 999.91V1024.92H450.11V1050.06H399.96C400.01 1033.34 400.05 1016.63 400.1 999.91L399.96 1000.06H425.1L424.96 999.91H424.97Z'
          fill='white'
        />
        <path
          d='M250.08 800.05C250.08 783.33 250.08 766.61 250.08 749.89L249.94 750.04H275.09C275.09 767.11 275.09 783.57 275.09 800.04C266.71 799.99 258.32 799.95 249.94 799.9L250.08 800.05Z'
          fill='white'
        />
        <path
          d='M275.09 874.91C266.71 874.96 258.32 875 249.94 875.05C249.99 866.67 250.03 858.28 250.08 849.9L249.94 850.05H274.94V875.05L275.09 874.91Z'
          fill='white'
        />
        <path
          d='M324.95 575.02V549.88H399.77V650.03H349.95V600.17H374.69V575.02H324.94H324.95Z'
          fill='black'
        />
        <path
          d='M400.1 750.04H375.15V700.24H350.27V725.04H324.96V649.89H350.1V674.81H400.11V750.04H400.1Z'
          fill='black'
        />
        <path
          d='M775.17 799.9V825.04H725.34V800.14H700.18V774.91L700.04 775.05H724.99V725.23H749.87V799.9H775.18H775.17Z'
          fill='black'
        />
        <path
          d='M750.16 875.05H725.2V899.71H700.31V875.05H650V850.32H750.16V875.05Z'
          fill='black'
        />
        <path
          d='M624.77 749.89H550.34V725.14H525.36V715.49H574.89V724.81H624.77V749.88V749.89Z'
          fill='black'
        />
        <path
          d='M700.169 774.91C683.449 774.91 666.73 774.89 650.02 774.88L650.159 775.02V750.06H675.01V715.45H700.03C700.03 735.25 700.03 755.15 700.03 775.05L700.169 774.91Z'
          fill='black'
        />
        <path
          d='M549.99 349.87H575.13V374.8H599.771V409.42H575.19V400.02H549.98V349.88L549.99 349.87Z'
          fill='black'
        />
        <path
          d='M650.02 774.88V799.83H674.8V824.56H625.45V775.02C633.65 775.02 641.91 775.02 650.17 775.02L650.03 774.88H650.02Z'
          fill='black'
        />
        <path d='M775.32 724.61V650.22H799.71V724.61H775.32Z' fill='black' />
        <path d='M500.12 750.04H474.98V725.08H425.31V715.46H500.13V750.04H500.12Z' fill='black' />
        <path d='M625.14 875.05H574.99V850.32H625.14V875.05Z' fill='black' />
        <path d='M424.97 374.87H450.11V409.47H400.31V400.1H424.96V374.87H424.97Z' fill='black' />
        <path d='M749.7 699.78H725.4V675.22H749.7V699.78Z' fill='black' />
        <path d='M499.98 374.87H525.12V400.01H499.98V374.87Z' fill='black' />
        <path
          d='M750.03 624.87V649.6H725.42V625.02C733.69 625.02 741.93 625.02 750.17 625.02L750.03 624.88V624.87Z'
          fill='black'
        />
        <path d='M649.84 374.74H625.41V350.22H649.84V374.74Z' fill='black' />
        <path d='M625.22 409.38V400.3H649.75V409.38H625.22Z' fill='black' />
        <path d='M524.99 399.87H550.13V409.49H524.99V399.87Z' fill='black' />
        <path
          d='M275.09 800.04V750.04H249.94V700.34H274.88V724.9H325.09C325.04 749.95 324.99 775 324.94 800.04L325.09 799.9H274.94L275.09 800.04Z'
          fill='black'
        />
        <path
          d='M274.93 650.02H299.66V674.63H275.08C275.08 666.36 275.08 658.12 275.08 649.88L274.94 650.02H274.93Z'
          fill='black'
        />
        <path
          d='M350.09 325.02V300.29H374.7V324.87C366.43 324.87 358.19 324.87 349.95 324.87L350.09 325.01V325.02Z'
          fill='black'
        />
        <path d='M924.89 900.26V924.61H900.45V900.26H924.89Z' fill='black' />
        <path d='M900.19 500.02H875.3V524.63H850.04V474.87H900.19V500.01V500.02Z' fill='black' />
        <path d='M850.18 475.02H800.03V450.29H850.18V475.02Z' fill='black' />
        <path d='M950.2 500.02H925.06V474.88H950.2V500.02Z' fill='black' />
        <path
          d='M725.15 350.02V325.29H749.76V349.87C741.49 349.87 733.25 349.87 725.01 349.87L725.15 350.01V350.02Z'
          fill='black'
        />
        <path d='M499.98 199.85H525.12V224.57H499.98V199.85Z' fill='black' />
        <path d='M174.59 174.74H100.3V100.18H174.6V174.73L174.59 174.74Z' fill='black' />
        <path d='M174.64 1024.77H100.25V950.38H174.64V1024.77Z' fill='black' />
        <path d='M1024.78 174.7H950.4V100.32H1024.78V174.71V174.7Z' fill='black' />
        <path d='M425.11 850.05H349.96V824.91H399.97V799.91H425.11V850.05Z' fill='black' />
        <path d='M400.1 774.9V800.04H375.38V774.9H400.1Z' fill='black' />
        <path
          d='M350.1 825.04C341.72 824.99 333.34 824.94 324.96 824.89L325.1 825.04V799.9L324.95 800.04C333.09 800.04 341.23 800.04 350.1 800.04V825.04Z'
          fill='black'
        />
        <path
          d='M274.94 875.05V850.05H249.94V799.91C258.32 799.96 266.71 800 275.09 800.05L274.94 799.91V825.05H325.09L324.95 824.9C324.95 833.02 324.95 841.14 324.95 849.77H300.16V875.05H274.94Z'
          fill='black'
        />
        <path
          d='M400.27 974.71H375.12V924.92L374.98 925.06H400.14C400.14 941.78 400.14 958.32 400.14 974.86L400.28 974.7L400.27 974.71Z'
          fill='black'
        />
        <path
          d='M375.31 900.21V875.23H399.64V900.08C391.6 900.08 383.38 900.08 375.15 900.08L375.31 900.22V900.21Z'
          fill='black'
        />
        <path
          d='M375.12 924.92H350.42V900.2C358.59 900.2 366.94 900.2 375.31 900.2C375.31 900.2 375.15 900.06 375.16 900.07C375.11 908.4 375.05 916.73 374.99 925.06L375.13 924.92H375.12Z'
          fill='black'
        />
        <path
          d='M425.11 1000.06H399.97C400.07 991.61 400.17 983.17 400.27 974.72C400.27 974.72 400.13 974.88 400.14 974.87C408.47 974.88 416.79 974.9 425.12 974.92V1000.06H425.11Z'
          fill='black'
        />
        <path d='M325.09 825.04H274.94V799.9H325.09V825.04Z' fill='white' />
      </g>
      <defs>
        <clipPath id='clip0_5909_12212'>
          <rect width='1125' height='1125' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
